import { ButtonPrimary, InputText } from '@/components/Form';
import { Heading, Paragraph } from '@/components/Typography';
import { Box, Stack } from '@chakra-ui/react';
import { Auth } from 'aws-amplify';
import { useState, type FC } from 'react';
import { useTwoFAStore } from './useTwoFAStore';

const TwoFA: FC = () => {
  const user = useTwoFAStore((s) => s.user);
  const successTwoFA = useTwoFAStore((s) => s.successTwoFA);
  const [code, setCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleConfirmOtp = async () => {
    if (!code) return;
    setIsLoading(true);
    try {
      const confirmedUser = await Auth.confirmSignIn(user, code, user.challengeName);
      successTwoFA(confirmedUser);
    } catch (err) {
      if (typeof err === 'object' && err !== null && 'code' in err) {
        const errorCode = (err as { code: string }).code;
        const errorMessage = (err as unknown as { message: string}).message;

        if (errorMessage.includes('session is expired')) {
          setErrorMessage('Sesi kamu telah berakhir, silahkan login ulang kembali.');
        } else {
          switch (errorCode) {
            case 'CodeMismatchException':
              setErrorMessage('Kode yang kamu masukkan salah, silakan coba lagi.');
              break;
            case 'ExpiredCodeException':
              setErrorMessage('Kode sudah kedaluarsa, silakan coba kode lain.');
              break;
            default:
              setErrorMessage('Terjadi kesalahan, silakan coba lagi.');
              break;
          }
        }
      } else {
        setErrorMessage('Terjadi kesalahan, silakan coba lagi.');
      }
    }
    setIsLoading(false);
  };

  return (
    <Stack spacing="24px">
      <Box>
        <Heading variant="Bold20" color="shade01" mb="8px">
          Buka Aplikasi Autentikator
        </Heading>
        <Paragraph variant="Default14" color="shade03">
          Masukkan 6 digit kode dari Google Authenticator.
        </Paragraph>
      </Box>
      <InputText
        type="text"
        label="Masukkan Kode"
        value={code}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => setCode(e.target.value)}
        errorMessage={errorMessage}
      />
      <ButtonPrimary
        width="100%"
        isLoading={isLoading}
        loadingText="Lanjutkan"
        isDisabled={!code}
        onClick={handleConfirmOtp}
      >
        Lanjutkan
      </ButtonPrimary>
    </Stack>
  )
}

export default TwoFA;
